export enum RouteEinstellungenMenuGroup {
	ALLGEMEIN = "Allgemein",
	BENUTZERVERWALTUNG = "Benutzerverwaltung"
}
